import { makeStyles } from "@material-ui/core/styles";

export const backgroundStyles = makeStyles({
  loginBackground: {
    background: "rgba(178, 199, 227, 1)"
  }
});
